import {
  RequestConfig,
  createJsonBodyRequestConfig
} from 'packages/http-client/fetcher';

export interface BackupWithholdingResponse {
  exempt: boolean;
}

/**
 * Get the current backup withholding status for IBA accounts
 * GET /v1/account/backupwithholding
 */
export const createGetBackupWithholdingRequest = (): RequestConfig<
  BackupWithholdingResponse
> => ({
  method: 'GET',
  url: '/v1/account/backupwithholding'
});

/**
 * Update the backup withholding status for IBA accounts
 * PUT /v1/account/backupwithholding
 */
export const createUpdateBackupWithholdingRequest = (
  exempt: boolean
): RequestConfig<{ success: boolean }> =>
  createJsonBodyRequestConfig({
    method: 'PUT',
    url: '/v1/account/backupwithholding',
    mutating: true,
    json: { exempt }
  });
